export const usersKeys = {
  all: ['users'] as const,
  list: (accountId: string) => [...usersKeys.all, accountId] as const,
}
